import { PaletteMode, Components, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';

export const MuiCollapseTheme = (mode: PaletteMode): Components<Theme>['MuiCollapse'] => {
  const { tokens } = themePalette(mode);

  return {
    styleOverrides: {
      root: {
        color: tokens.textPrimary,
      },
      wrapper: {
        // Wrapper for the collapsible content
      },
      wrapperInner: {
        // Inner wrapper
      },
    },
  };
};
